import { combineReducers } from 'redux';
import allZones from './map/allZones';
import selectedZones from './dashboard/selectedZones';
import alerts from './alert/alerts';
import map from './map/map';
import language from './language/language';
import approvedAreas from './map/approvedAreas';
import allLocalZones from './map/allLocalZones';
import selectedApprovedAreas from './map/selectedApprovedAreas.js';
import selectedDashboardUavos from './dashboard/selectedUavos';
import isDashboardItemSelected from './dashboard/isDashboardItemSelectedReducer';
import mappingUavos from './map/mappingUavos';
import selectedDashboardMissionsApprovals from './dashboard/selectedMissionsApprovals';
import selectedDashboardOperationsApprovals from './dashboard/selectedOperationsApprovals';
import weatherLayer from './map/weatherLayer';
import timezone from './time/timezone';
import dronesFiltersTypes from './map/dronesFiltersTypes';
import zonesCategories from './map/zoneCategories';
import getFontSize from './fontSize/getFontSize';
import heightUnit from './heightUnit/heightUnit';

const allReducers = combineReducers({
  allZones,
  selectedZones,
  alerts,
  map,
  language,
  approvedAreas,
  selectedApprovedAreas,
  selectedDashboardUavos,
  mappingUavos,
  selectedDashboardMissionsApprovals,
  selectedDashboardOperationsApprovals,
  weatherLayer,
  timezone,
  allLocalZones,
  dronesFiltersTypes,
  zonesCategories,
  isDashboardItemSelected,
  getFontSize,
  heightUnit,
});

export default allReducers;
